module.exports = __webpack_public_path__ + "img/home_birthday_new1.1073a2b2.png";